exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle-container{background:#a9bdd8;padding:30px;border-radius:50%;width:48px;height:48px}.circle-icon{font-size:48px;color:white}.user-details-form .save-btn{width:calc(100% - 32px);margin:0 16px}\n", ""]);

// exports
